/* global document */
import events from 'events';
import pipeline from '../component/pipeline';
import Channel from './context/channel';
import context from './context/';
import View from '../component/view';
import util from '../lib/util';
import appEvents from './context/app_events';
import EventBus from './context/eventbus';
import modules from './module';
import shortcuts from './module/shortcuts';
import customUI from './module/customUI';
import firstmessage from './module//firstmessage/index.js';
import snap from './module/snap';
import plugin from './module/inputplugins/index.js';
import extension from './extension/';
import './index.scss';
import './iconfont.scss';


export default class APP extends events {
  constructor(config) {
    super(config);
    /**
     * 数据层
    */
    this.model = config.model;
    /**
     * 当前环境
     */
    this.env = config.env;

    /**
     * 是否支持 webp
     */
    this.isWebp = util.detectWebp();

    /**
     * jsridge对象
     */
    this.bridge = config.bridge;
    /**
     * 埋点对象
     */
    this.log = config.log;
   /**
     * 应用配置
     */
    this.appConfig = config.appConfig;
    /**
     * the init param from lazada
     */
    this.param = config.param;

    this.listeners = [];
    /**
     * 必要入参数
     */
    this.essentials = config.essentials;

    /**
     * view 对象
     */
    this.view = this.initView();
    /**
     * 服务渠道
     */
    this.channel = this.channel();

    /**
     * 事件总线
     */
    this.eventBus = EventBus;

    /**
     * chatUuid
     */
    this.chatUuid = null;

    this.liveAgent = {};

    // 业务主动调用
    // this.start();
    context(this);
    modules(this);
    extension(this);
  }
  /**
   * 工具类
   * @returns {{waterfall}}
   */
  get util() {
    return util;
  }

  /**
   * app 支持的事件枚举
   * @returns {{..}}
   */
  get events() {
    return appEvents;
  }

  /**
   * pipeline
   * @returns {Object}
   */
  register(key, fn) {
    pipeline.register(key, fn);
  }

  /**
   * 向 pipeline 中发送消息
   */
  postMessage(data) {
    return pipeline.push(data, this);
  }

  /**
   * 初始化 UI 对象
   * @returns {View}
   * @private
   */
  initView() {
    // 是否是外部合作UI（没有顶部导航api的），没想到好名字= =
    const isExternalUI = true;
    const view = new View({
      isExternalUI,
      log: this.log,
      bridge: this.bridge,
      container: this.essentials.container,
      appConfig: this.param,
    });

    this.isExternalUI = isExternalUI;

    // UI 渲染之后, 服务渠道加载之前
    this.emit(this.events.AFTER_VIEW_READY);
    view.on('pull', () => {
      // 历史消息加载
    });
    return view;
  }

  /**
   * 初始化服务渠道
   * @private
   */
  channel() {
    const channel = new Channel(this);

    // this.on(this.events.CHANNEL_OCS_ONLINE, () => {
    //   this.appendSystemMessage('进入云客服了！');
    // });

    this.on(this.events.CHANNEL_OCS_OFFLINE, (data) => {
      /**
       * 出评价逻辑 https://gw.alicdn.com/tps/TB1skELKFXXXXcLXVXXXXXXXXXX-476-137.png
       */
      if (data.closeReasonType === '0' || String(data.closeReasonType) === '2' && String(data.closeReasonDetail) === '10') {
        const appConfig = this.appConfig;
        const { appName, imsid } = appConfig.get('base');
        const actionTips = appConfig.get('ocs').actionTips;
        const memberType = appConfig.get('user').memberType;
        const tip = actionTips && actionTips.afterComment && actionTips.afterComment.tip || '';
        this.appendMessage({
          type: 'rate',
          body: {
            memberType,
            appName,
            imsid,
            tip,
            sid: data.sid,
            serviceUserId: data.serviceUserId,
            servicerName: data.servicerName,
          },
        });
      }
      channel.switchToRobot();
    });

    // this.on(this.events.CHANNEL_ROBOT_ONLINE, () => {
    //   this.view.header.switchRole('robot');
    // });

    return channel;
  }


  /**
   * app start
   */
  start() {
    // this.channel.ocs.online({
    //   connectType: 'dispatch',
    //   skillGroupId: '130001',
    // });
    const tasks = [];

    // 加载所有与业务逻辑无关的功能
    // module(this);

    // 展示欢迎语
    tasks.push((app, done) => {
      this.welcomeMsg();
      done();
    });

    tasks.push(snap);
    // 展示历史消息
    // tasks.push(history);
    // UI设置
    tasks.push(customUI);
    // 展示首问卡片
    if (this.param.greetingType === 'banner') {
      tasks.push(firstmessage);
    }
    // 快捷短语
    tasks.push(shortcuts);
    // 输入框插件
    tasks.push(plugin);
    // 对话渠道
    if (this.appConfig.get('ocs').isNeedResume) {
      // 对话渠道切换至云客服
      tasks.push((app, done) => {
        app.channel.ocs.resume();
        app.channel.curRole = 'ocs';
        done();
      });
    } else {
      // 对话渠道切换至机器人
      tasks.push((app, done) => {
        app.channel.switchToRobot();
        done();
      });
    }
    // 公告最重要最后显示
    // tasks.push(notice);

    // tasks.push(taphold);

    // tasks.push(headmenu);

    // 串行加载所有模块
    util.waterfall(tasks, this).then(() => {
      this.emit(this.events.APP_READY);
    }, (err) => {
      console.log(err);
      console.log('app load fail');
    });

    this.parseMessages();
    this.urlLogic();
    this.bindOperationEvents();
  }

  /**
   * 欢迎语逻辑
   * @param {any} next
   */
  welcomeMsg() {
    const appConfig = this.appConfig;
    const qs = appConfig.get('qs');
    const session = appConfig.get('ocs');
    const config = appConfig.get('appConfig');
    // 断点续连
    if (session.continuedResume) {
      this.appendMessage({
        type: 'robot',
        body: {
          isFollow: false,
          text: this.util.lang.get('OSP:WELCOME:CONTINUE'),
        },
      });
    } else if (config.welcomeMsg && !qs.attemptquery &&
     !session.isNeedResume && !qs.bizOrderId && !qs.bizId && !qs.orderId &&
     !qs.ggOrderId && !qs.postorderId) {
      this.appendMessage({
        type: 'welcomemsg',
        body: {
          isFollow: false,
          text: config.welcomeMsg,
        },
      });
    }
  }

  /**
   * 用户一进页面需要展示的消息列表
   */
  parseMessages() {
    // this.shortcuts.push({
    //   isAdd: true,
    //   shortcuts: [{
    //     code: 'dispatch',
    //     icon: 'service',
    //     title: 'LiveAgent',
    //     type: 'dispatch',
    //   }],
    // });
    const appConfig = this.appConfig;
    const messages = appConfig.get('messages') || [];
    messages.forEach((t) => {
      this.appendMessage({
        type: t.type,
        body: t.data,
      });
    });
  }

  /**
   * url参数的一些逻辑
   */
  urlLogic() {
    const appConfig = this.appConfig;
    const qs = appConfig.get('qs');
    const session = appConfig.get('ocs');
    const onedata = appConfig.get('onedata');
    if (qs.type === 'connect') {
      if (qs.bizType) {
        this.channel.robot.bizType = qs.bizType;
      }
      // 带了bizOrderId或者bizId，直接发给机器人转人工
      if (qs.bizOrderId || qs.bizId) {
        this.view.footer.submit({
          q: qs.bizOrderId || qs.bizId,
          subType: 'connect',
        });
      } else {
        // 说一句话转人工
        this.channel.robot.subType = 'connect';
      }
    }
    // url上直接发送一句话
    if (qs.attemptquery && !session.isNeedResume) {
      this.view.footer.submit(util.htmlEncodeAll(qs.attemptquery));
    }
    // url带丁订单号
    if (onedata && onedata.showtype && !session.isNeedResume) {
      this.appendMessage({
        type: 'order',
        body: {
          onedata,
        },
      });
      const d = onedata.params[0];
      this.view.footer.submit(d.idStr || String(d.id), d.type, false);
    }
    if (qs.question) {
      this.view.footer.setTipText(qs.question);
    }
  }

  /**
   * TODO
   * 更好的方式
   */
  initOrderFunc() {

  }
  /**
   * 给运营用的dom钩子
   */
  bindOperationEvents() {
    const $container = this.view.body.$container;
    const footer = this.view.footer;
    $container.delegate('.J_HookSendText', 'tap', (ev) => {
      const $target = $(ev.currentTarget);
      footer.submit($target.text());
    });
    $container.delegate('.J_HookShare', 'tap', (ev) => {
      const $target = $(ev.currentTarget);
      this.bridge.share({
        title: $target.attr('data-title'),
        text: $target.attr('data-text'),
        url: $target.attr('data-url'),
        image: $target.attr('data-image'),
      });
    });
    $container.delegate('.J_HookSelectOrder', 'tap', () => {
      this.orderList.show({
        source: 'robot',
      });
    });
  }

  /**
   * 添加APP各生命周期对应的事件
   * @param {*} key
   * @param {*} fn
   */
  addListener(key, fn) {
    this.listeners.push({ key, fn });
  }
  /**
   * 以对象的形式添加APP各生命周期对应的事件
   * @param {*} ls
   */
  addListeners(ls = {}) {
    const keys = Object.keys(ls);
    keys.forEach((key) => {
      this.listeners.push({
        key,
        fn: ls[key],
      });
    });
  }

  sendMsg(data, type = 'text', show = true, post = true) {
    this.view.footer.submit(data, type, show, post);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.js